module.exports = __webpack_public_path__ + "static/img/Horizontal shore 0,9 meter.11b6ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Horizontal shore 0,9 meter.jpg
// module id = 80
// module chunks = 1